<style lang="css" scoped>
.avatar-uploader-icon {
    padding-top: 36%;
    font-size: 28px;
    color: #8c939d;
    width: 93px;
    height: 93px;
    text-align: center;
}

</style>

<template lang="html">

<el-row :gutter="10">
    <el-form>

        <el-col :span="8" v-for="(data,position) in datas" class="basic-margin">
            <el-card style="padding-bottom:20px;">
                <el-col :md="8" style="margin-top:10px;text-align:center;">
                    <el-upload @click.native="uploadClick(data)" class="avatar-uploader" :data="{floder:'localnews',field:'icon'}" :action="baseUrl+'upload/uploadPic'" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img v-if="data.icon" style="width:83px;height:83px;" :src="data.icon" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>

                    <!-- <span v-show="!data.icon" style="color:red;height:30px;">菜单icon不能为空！</span> -->
                    <el-popover
                      placement="bottom"
                      width="160"
                      v-model="data.visible">
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <img :src="staticUrl+'static/img/shaiche.png'"  @click="onSelectIcon(data,'static/img/shaiche.png')"></img>
                        </el-col>
                        <el-col :span="8">
                          <img :src="staticUrl+'static/img/maimaiche.png'"  @click="onSelectIcon(data,'static/img/maimaiche.png')"></img>
                        </el-col>
                        <el-col :span="8">
                          <img :src="staticUrl+'static/img/qiuzhu.png'"  @click="onSelectIcon(data,'static/img/qiuzhu.png')"></img>
                        </el-col>
                        <el-col :span="8" class="basic-margin">
                          <img :src="staticUrl+'static/img/fabu.png'"  @click="onSelectIcon(data,'static/img/fabu.png')"></img>
                        </el-col>
                        <el-col :span="8" class="basic-margin">
                          <img :src="staticUrl+'static/img/weizhang.png'" @click="onSelectIcon(data,'static/img/weizhang.png')"></img>
                        </el-col>
                        <el-col :span="8" class="basic-margin">
                          <img :src="staticUrl+'static/img/yongche.png'" @click="onSelectIcon(data,'static/img/yongche.png')"></img>
                        </el-col>
                        <el-col :span="8" class="basic-margin">
                          <img :src="staticUrl+'static/img/weixiu.png'" @click="onSelectIcon(data,'static/img/weixiu.png')"></img>
                        </el-col>
                        <el-col :span="8" class="basic-margin">
                          <img :src="staticUrl+'static/img/baoliao.png'" @click="onSelectIcon(data,'static/img/baoliao.png')"></img>
                        </el-col>
                        <el-col :span="8" class="basic-margin">
                          <img :src="staticUrl+'static/img/zijia.png'" @click="onSelectIcon(data,'static/img/zijia.png')"></img>
                        </el-col>
                      </el-row>
                      <el-button slot="reference" type="text" @click="data.visible = !data.visible">选择素材图标</el-button>
                    </el-popover>
                </el-col>

                  <el-button type="text" style="float:right;" @click="delMenu(data.id,position)">删除</el-button>
                <el-col :md="12" style="margin-top:10px;">
                    <el-input v-model="data.name" placeholder="字数不超过5个汉字(必填)"></el-input>
                    <!-- <span v-show="!data.name" style="color:red;height:30px;">菜单名不能为空！</span> -->
                    <!-- <span v-show="data.name&&data.name.length>5" style="color:red;height:30px;">菜单名字数不能超过5个字</span> -->
                    <el-input v-model="data.url" placeholder="跳转网页(必填)" style="margin-top:40px;"></el-input>
                    <!-- <span v-show="!data.url" style="color:red;height:30px;">跳转网页不能为空！</span> -->
                </el-col>
            </el-card>
        </el-col>
        <el-col class="basic-margin">
            <el-button type="primary"  @click="submit">应用</el-button>
            <el-button @click="addItem">添加一项</el-button>
        </el-col>
    </el-form>
</el-row>

</template>

<script>

import Config from '@/framework/configs/Config'
import channelModel from '@/framework/models/channelModel'
export default {
  name: 'home-config',
  data: function () {
    return {
      channelId: null,
      selectItem: null,
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      staticUrl: location.origin + location.pathname,
      datas: [{
        name: null,
        url: null,
        icon: null,
        visible: false
      }]
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)

    if (userInfo.loginPath == 'channel') {
      this.channelId = userInfo.id
      this.loadList()
    }
  },
  methods: {
    onSelectIcon: function (data, path) {
      data.icon = this.staticUrl + path
    },
    submit: function () {
      let _this = this

      let datas = _this.datas
      for (var i = 0; i < datas.length; i++) {
        let data = datas[i]

        if (!data.icon) {
          this.$message({
            type: 'warning',
            message: '菜单icon不能为空！'
          })
          return
        }

        if (!data.name) {
          this.$message({
            type: 'warning',
            message: '菜单名不能为空！'
          })
          return
        }

        if (data.name.length > 5) {
          this.$message({
            type: 'warning',
            message: '菜单名字数不能超过5个字'
          })
          return
        }

        if (!data.url) {
          this.$message({
            type: 'warning',
            message: '跳转网页不能为空！'
          })
          return
        }
      }

      let params = {
        channelId: _this.channelId,
        menus: JSON.stringify(_this.datas)
      }

      let loading = _this.$loading({
        lock: true,
        text: '正在提交中,请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let listener = {
        success: function (dataInfo) {
          loading.close()
          _this.$message({
            type: 'success',
            message: '菜单已生效！'
          })
        },
        error: function () {
          loading.close()
        }
      }

      channelModel.updateMenus(_this, params, listener)
    },
    delMenu: function (id, position) {
      this.datas.splice(position, 1)
    },
    uploadClick: function (data) {
      this.selectItem = data
    },
    addItem: function () {
      this.datas.push({
        name: '',
        url: '',
        icon: ''
      })
    },
    handleAvatarSuccess: function (res, file) {
      this.selectItem.icon = this.baseImageUrl + res.datas
    },
    beforeAvatarUpload: function (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt2M = file.size / 1024 < 150
        if (!isLt2M) {
          _this.$message.error('上传头像图片大小不能超过 150 KB!')
          reject()
          return
        }
        var isAllow = false
        var reader = new FileReader()
        reader.onload = function (e) {
          var data = e.target.result
          // 加载图片获取图片真实宽度和高度
          var image = new Image()
          image.onload = function () {
            var width = image.width
            var height = image.height

            if (width == 83 && height == 83) {
              resolve()
            } else {
              _this.$message({
                type: 'error',
                message: '图片必须等于83px*83px'
              })
              reject()
            }
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
      return promise
    },
    loadList: function () {
      let _this = this
      let params = {
        id: _this.channelId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          if (datas.menus) {
            _this.datas = JSON.parse(datas.menus)
          }
        }
      }

      channelModel.selectChannelByID(_this, params, listener)
    }
  }
}

</script>
